import React from "react";
import { useI18n } from "../i18n/I18nContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PaymentRegionsBlock from "../components/PaymentRegionsBlock";

export default function PaymentInfo() {
  const { t } = useI18n();

  return (
    <div data-testid="payment-info-page">
      <Header />
      <div className="max-w-5xl mx-auto px-5 md:px-10 py-20">
        <div className="mb-12">
          <div className="overline mb-3">{t("payInfo.overline")}</div>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight">{t("payInfo.title")}</h1>
          <p className="mt-4 text-neutral-400 max-w-2xl">{t("payInfo.subtitle")}</p>
        </div>

        {/* Tier badges */}
        <div className="grid md:grid-cols-2 gap-4 mb-10">
          <div className="card-imperial p-6" data-testid="tier-standard-card">
            <div className="flex items-baseline justify-between">
              <div className="overline">Standard</div>
              <div className="font-serif text-4xl">$499<span className="text-neutral-500 text-sm ml-1">US</span></div>
            </div>
            <p className="mt-3 text-sm text-neutral-400">{t("payInfo.standardLine")}</p>
          </div>
          <div className="card-imperial p-6 gold-shimmer-border border-[#d4af37]/40" data-testid="tier-member-card">
            <div className="flex items-baseline justify-between">
              <div className="overline text-[#d4af37]">LeadmotivH HAYTI member</div>
              <div className="font-serif text-4xl text-[#d4af37]">$399<span className="text-neutral-500 text-sm ml-1">US</span></div>
            </div>
            <p className="mt-3 text-sm text-neutral-400">{t("payInfo.memberLine")}</p>
          </div>
        </div>

        <PaymentRegionsBlock idPrefix="payinfo" />
      </div>
      <Footer />
    </div>
  );
}
